import React from 'react';
import { Table } from 'react-bootstrap';

const Transactions = () => {
	return (
		<div>
			<h1 style={{ textAlign: 'left', padding: '30px 0px 10px 30px' }}>TRANSACTIONS</h1>
			<div style={{ paddingLeft: '30px', paddingRight: '30px' }}>
				<Table striped bordered hover responsive>
					<thead>
						<tr>
							<th>Transaction No.</th>
							<th>Bill Date</th>
							<th>Amount</th>
							<th>Dues(if any)</th>
							<th>Final Amount Payed</th>
							<th>Transaction Date</th>
							<th>Status</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>1</td>
							<td>0001</td>
							<td>1/2/22</td>
							<td>102</td>
							<td>1300</td>
							<td>1/3/22</td>
							<td>Successfull</td>
						</tr>
						<tr>
							<td>2</td>
							<td>0011</td>
							<td>1/2/22</td>
							<td>120</td>
							<td>1400</td>
							<td>1/3/22</td>
							<td>Successfull</td>
						</tr>
						<tr>
							<td>3</td>
							<td>0001</td>
							<td>1/2/22</td>
							<td>102</td>
							<td>1300</td>
							<td>1/3/22</td>
							<td>Successfull</td>
						</tr>
					</tbody>
				</Table>
			</div>
		</div>
	);
};

export default Transactions;
